<template>
  <div>
    <can action="edit" subject="timeslots">
      <el-form label-position="left" label-width="100px" :model="timeslot">
        <el-row>
        <el-form-item label="Title">
          <el-input v-model="timeslot.title" placeholder="Title"></el-input>
        </el-form-item>

        <el-form-item label="Days">
          <span>
            <el-select v-model="timeslot.start_day" placeholder="Start Day">
              <el-option v-for="(day, i) in weekdays" :value="i" :label="day" :key="i"></el-option>
            </el-select>
          </span>
          <span style="margin: auto 1em;">to</span>
          <span>
            <el-select v-model="timeslot.end_day" placeholder="Start Day">
              <el-option v-for="(day, i) in weekdays" :value="i" :label="day" :key="i"></el-option>
            </el-select>
          </span>
        </el-form-item>

        <el-form-item label="Times">
          <span>
            <el-time-picker
              v-model="timeslot.start_time"
              value-format="HH:mm:ss"
              placeholder="Start Time"
            ></el-time-picker>
          </span>
          <span style="margin: auto 1em;">to</span>
          <span>
            <el-time-picker
              v-model="timeslot.end_time"
              value-format="HH:mm:ss"
              placeholder="End Time"
            ></el-time-picker>
          </span>
        </el-form-item>

        <el-form-item label="Colour">
          <el-color-picker v-model="timeslot.colour"></el-color-picker>
        </el-form-item>
        </el-row>
        <el-row class="dialog-footer clearfix">
          <span class="pull-right">
            <el-button id="cancel" type="danger" @click="cancel" plain>Cancel</el-button>
            <el-button
              id="save"
              type="primary"
              :loading="savingTimeslot"
              @click="saveTimeslot"
              plain
            >Save</el-button>
          </span>
        </el-row>
      </el-form>

    </can>
  </div>
</template>

<script>
import { pick } from 'lodash';
import Can from '@/components/permissions/Can';

export default {
  name: 'TimeslotEdit',
  components: { Can },
  data() {
    return {
      savingTimeslot: false,
      timeslot: null,
    };
  },
  props: ['weekdays', 'isNew'],
  created() {
    const fields = [
      'id',
      'title',
      'colour',
      'start_day',
      'end_day',
      'start_time',
      'end_time',
      'live',
    ];

    /* eslint-disable indent */
    this.timeslot = !this.isNew
      ? pick(this.$store.state.timeslots.selectedTimeslot, fields)
      : fields.reduce((acc, f) => {
          acc[f] = null;
          if (f === 'colour') acc[f] = '#683090';
          if (f === 'live') acc[f] = true;
          return acc;
        }, {});
    /* eslint-enable indent */
  },
  methods: {
    cancel() {
      this.$emit('cancel');
    },
    saveTimeslot() {
      this.$emit('save', this.timeslot);
    },
  },
};
</script>



// WEBPACK FOOTER //
// TimeslotEdit.vue?6508091d